import { useEffect, useContext, useState } from 'react'
import { get, isNil } from 'lodash'

import { AppContext } from '../context/app'
import gql from '../utils/graphql'
import { verifyIdentityIntercom } from '../graphql/queries'

const useIntercom = appId => {
  const { user } = useContext(AppContext)

  useEffect(() => {
    const bootIntercom = async () => {
      const hash = get(
        await gql({
          operation: verifyIdentityIntercom,
          path: 'verifyIdentityIntercom',
          variables: { email: get(user, 'email') }
        }),
        'body.hash'
      )
      if (hash) {
        window.Intercom('boot', {
          app_id: appId,
          horizontal_padding: 0,
          vertical_padding: 0,
          email: get(user, 'email'),
          name: get(user, 'name'),
          user_hash: hash
        })
      }
    }

    if (typeof window !== 'undefined' && window.Intercom) {
      if (get(user, 'email')) {
        bootIntercom()
      }
    }
  }, [appId, user])
}

export default useIntercom
